import { SVGProps } from 'react';
const SVGTurnBack = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={16} fill="none" {...props}>
    <path
      stroke="#8A92A6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17 4.5H6c-1.87 0-2.804 0-3.5.402A3 3 0 0 0 1.402 6C1 6.696 1 7.63 1 9.5s0 2.804.402 3.5A3 3 0 0 0 2.5 14.098c.696.402 1.63.402 3.5.402h7m4-10-3-3m3 3-3 3"
    />
  </svg>
);
export default SVGTurnBack;
